import { useEffect } from "react";

import StudentsManager from "../components/APanel/StudentsManager";
import GroupManager from "../components/APanel/GroupManager";
import PreloadAppData from "../components/Utils/PreloadAppData";
import Footer from "../components/Footer";

function APanel() {
   useEffect(() => {
      document.title = "Instruire Auto | APanel";
   }, []);

   return (
      <main className="main">
         <section className="home-admin">
            <StudentsManager />
            <GroupManager />
         </section>

         <PreloadAppData />
         <Footer />
      </main>
   );
}

export default APanel;
